import { Observable, map, of } from 'rxjs';
import { EstablishmentService } from '../../services/establishment/establishment.service';
import { PermissionService } from '../../services/permission/permission.service';
import { UserAccessApi } from '../../common-files/user-access-api';

// the branch admin's view of a staff member's access: only establishment roles
// below the admin's own weight, at the branches the admin works on.
export function establishmentUserAccessApi(
  establishmentService: EstablishmentService,
  permissionService: PermissionService
): UserAccessApi {
  return {
    canManage: permissionService.can('branch-staff', 'can_manage_users'),
    allowCentralAssignment: false,
    getAccess: (sumId) => establishmentService.getStaffAccess(sumId),
    listAssignableRoles: () =>
      establishmentService.listAssignableRoles().pipe(map((res: any) => res?.data?.roles || [])),
    // the establishments the signed-in admin works on come with the sign-in response
    listEstablishments: (): Observable<any[]> => {
      try {
        const stored = JSON.parse(localStorage.getItem('establishments') || '[]');
        return of(Array.isArray(stored) ? stored : []);
      } catch {
        return of([]);
      }
    },
    assignRole: (sumId, payload) =>
      establishmentService.assignStaffRole(sumId, {
        establishmentId: Number(payload.establishmentId),
        roleKey: payload.roleKey,
        validUntil: payload.validUntil ?? null,
      }),
    setRoleStatus: (sumId, suremId, active) => establishmentService.setStaffRoleStatus(sumId, suremId, active),
    listAssignablePermissions: () =>
      establishmentService.listAssignablePermissions().pipe(map((res: any) => res?.data?.permissions || [])),
    grantPermission: (sumId, suremId, svpId) => establishmentService.grantStaffPermission(sumId, suremId, svpId),
    setPermissionStatus: (sumId, supdId, active) =>
      establishmentService.setStaffPermissionStatus(sumId, supdId, active),
    setPermissionsStatus: (sumId, supdIds, active) =>
      establishmentService.setStaffPermissionsStatus(sumId, supdIds, active),
    removeFromEstablishment: (sumId, establishmentId) => establishmentService.removeStaff(sumId, establishmentId),
  };
}
